// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"52":"consultation","368":"labs-v2"}[chunkId] || chunkId) + "." + {"52":"ec855637","110":"d5d9b141","189":"2e48116f","368":"fab207d7","525":"29d2dabb","571":"8e7c411a","659":"ec855637","721":"29d2dabb","834":"e869ad06"}[chunkId] + ".chunk.css";
};